import { render } from "./recording.vue?vue&type=template&id=7999248c&scoped=true"
import script from "./recording.vue?vue&type=script&lang=js"
export * from "./recording.vue?vue&type=script&lang=js"

import "./recording.vue?vue&type=style&index=0&id=7999248c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7999248c"]])

export default __exports__